/**
 * Resolves Backstage scaffolder ui:options templates of the form ${{ FieldName }}
 * without executing Nunjucks against the full form context (avoids template injection).
 */
const SINGLE_FIELD_TEMPLATE = /^\$\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}$/;

export function resolveFormFieldTemplate(
  template: string,
  formData: Record<string, unknown> | undefined,
): string {
  if (!template?.trim()) {
    return '';
  }

  const trimmed = template.trim();
  const match = trimmed.match(SINGLE_FIELD_TEMPLATE);
  if (!match) {
    console.warn(
      `Unsupported field template (expected exactly \${{ FieldName }}): ${trimmed}`,
    );
    return '';
  }

  const fieldName = match[1];
  const value = formData?.[fieldName];
  if (value === undefined || value === null) {
    return '';
  }
  return typeof value === 'string' ? value.trim() : String(value).trim();
}
